module.exports = __webpack_public_path__ + "static/media/back.3b0db985.svg";